exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\r\n.nav-wrapper{\r\n  z-index: 10000;\r\n}\r\n.dropdown-toggle{\r\n  margin-right: 30px;\r\n  color:#007b85;\r\n}\r\n.dropdown-toggle:hover{\r\n  background-color: white;\r\n}\r\n\r\n.nav>li>a {\r\n    padding: 0px 0px;\r\n}\r\n\r\n.nav .open>a, .nav .open>a:focus, .nav .open>a:hover {\r\n    background-color: white;\r\n}\r\n\r\n.userdetails{\r\n\tcolor: black;\r\n}\r\n\r\nnav {\r\n  position: fixed;\r\n  width: 100%;\r\n  z-index: 10000;\r\n}\r\n\r\n.app-name {\r\n\tcolor: #007b85;\r\n\tfont-size: 20px;\r\n\tfont-weight: bold;\r\n}\r\n#ctoshome{\r\n\tbackground-image: url(\"/assets/images/ctoshome.png\");\r\n\tbackground-repeat: no-repeat;\r\n\tbackground-position: center;\r\n\tbackground-size: cover;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/nav-bar/nav-bar.component.css
// module id = 470
// module chunks = 1